import LyCascader from './src/index.vue'

LyCascader.install = function (Vue) {
    Vue.component(LyCascader.name, LyCascader)
}

export default LyCascader



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/cascader/index.js
// module id = null
// module chunks = 